//Lista de bancos PSE Colombia obtida via PayU GET_BANKS_LIST (PSE/CO) em 2026-05-15
//Fonte: https://api.payulatam.com/payments-api/4.0/service.cgi (production)
//Atualizar periodicamente — bancos podem mudar codigo ou ser desabilitados (PSE AVANZA migration)
export default [
    {
        "id": "7b599159-a28e-4413-a110-2f565ff211bf",
        "description": "ACCION FIDUCIARIA",
        "pseCode": "1831"
    },
    {
        "id": "75d819e6-26ff-4cd1-bbc0-689239f34e31",
        "description": "ALIANZA FIDUCIARIA",
        "pseCode": "1815"
    },
    {
        "id": "6d95c62b-ca68-4179-866e-59784a186ee0",
        "description": "BAN100",
        "pseCode": "1558"
    },
    {
        "id": "8fc02c26-3776-4032-bfde-a9227e1f05e1",
        "description": "BANCAMIA S.A.",
        "pseCode": "1059"
    },
    {
        "id": "8a6b8f9d-7fe9-4250-ae58-c0b828f39728",
        "description": "BANCO AGRARIO",
        "pseCode": "1040"
    },
    {
        "id": "cad35364-06c2-42bd-a13f-11f50cbee368",
        "description": "BANCO AV VILLAS",
        "pseCode": "1052"
    },
    {
        "id": "9987a118-ffe0-47ea-a750-eb54ac195819",
        "description": "BANCO BBVA COLOMBIA S.A.",
        "pseCode": "1013"
    },
    {
        "id": "628719ba-a7f6-499c-b6e6-738016492c89",
        "description": "BANCO CAJA SOCIAL",
        "pseCode": "1032"
    },
    {
        "id": "f6311e01-ee1a-4bef-911a-78d9e02f0633",
        "description": "BANCO COOPERATIVO COOPCENTRAL",
        "pseCode": "1066"
    },
    {
        "id": "24f1a4b6-ca61-4ff1-b76e-711a795215d6",
        "description": "BANCO DAVIVIENDA",
        "pseCode": "1051"
    },
    {
        "id": "6c2b4943-9370-429b-ab73-58c9ae57fd13",
        "description": "BANCO DE BOGOTA",
        "pseCode": "1001"
    },
    {
        "id": "67b5271e-e79f-4497-a309-c2b8c5133b78",
        "description": "BANCO DE OCCIDENTE",
        "pseCode": "1023"
    },
    {
        "id": "4942ca0f-7e99-4ac2-a95d-5335b97e627a",
        "description": "BANCO FALABELLA",
        "pseCode": "1062"
    },
    {
        "id": "5b0f7ca3-0729-4569-b326-0f404abbb3e0",
        "description": "BANCO FINANDINA S.A. BIC",
        "pseCode": "1063"
    },
    {
        "id": "9117f238-5e3d-4b98-a2e6-a186a52052e8",
        "description": "BANCO GNB SUDAMERIS",
        "pseCode": "1012"
    },
    {
        "id": "19a18808-8ee4-44b2-a2b2-87901d042dae",
        "description": "BANCO ITAU",
        "pseCode": "1006"
    },
    {
        "id": "b822187e-9dce-408f-9025-2e2118cf60e8",
        "description": "BANCO J.P. MORGAN COLOMBIA S.A.",
        "pseCode": "1071"
    },
    {
        "id": "d0bdd9df-d70f-420f-8754-13026bcafdc1",
        "description": "BANCO MUNDO MUJER S.A.",
        "pseCode": "1047"
    },
    {
        "id": "7e00d6b8-7354-4763-bfbd-4b05223be1d3",
        "description": "BANCO PICHINCHA S.A.",
        "pseCode": "1060"
    },
    {
        "id": "4b7d2fe6-c950-4aa0-b0a2-f64c21fbf85c",
        "description": "BANCO POPULAR",
        "pseCode": "1002"
    },
    {
        "id": "3034e21c-6035-48c5-87b1-dd6895c451ac",
        "description": "BANCO SANTANDER COLOMBIA",
        "pseCode": "1065"
    },
    {
        "id": "363e8b55-f26a-4047-91dd-0023f98fc02c",
        "description": "BANCO SERFINANZA",
        "pseCode": "1069"
    },
    {
        "id": "6ffaa6a9-c9c0-4678-8b25-7847ca50b3b0",
        "description": "BANCO UNION",
        "pseCode": "1303"
    },
    {
        "id": "0657f924-b960-4bc8-a190-0ba11fd82f42",
        "description": "BANCOLOMBIA",
        "pseCode": "1007"
    },
    {
        "id": "489da367-46d1-477c-8760-c6ac6599de93",
        "description": "BANCOOMEVA S.A.",
        "pseCode": "1061"
    },
    {
        "id": "9179f49f-f0b0-42d8-9ea2-fc44ff295339",
        "description": "BOLD CF",
        "pseCode": "1808"
    },
    {
        "id": "396573f1-7a6a-48c0-89eb-b449fc625e87",
        "description": "CFA COOPERATIVA FINANCIERA",
        "pseCode": "1283"
    },
    {
        "id": "0781ce66-a279-44a5-b856-122891703654",
        "description": "CITIBANK",
        "pseCode": "1009"
    },
    {
        "id": "b3a5407c-3272-4a19-967f-fa64247287c0",
        "description": "COINK SA",
        "pseCode": "1812"
    },
    {
        "id": "043343c5-4223-4b2c-943d-acc974e49a84",
        "description": "COLTEFINANCIERA",
        "pseCode": "1370"
    },
    {
        "id": "0bb33357-322f-4550-a3db-827cd83a3c3b",
        "description": "CONFIAR COOPERATIVA FINANCIERA",
        "pseCode": "1292"
    },
    {
        "id": "5a2b742a-23ce-42b7-983a-183c91bf221a",
        "description": "COTRAFA",
        "pseCode": "1289"
    },
    {
        "id": "14e18b27-8e48-41a6-b78b-409bf449e8a7",
        "description": "CREZCAMOS",
        "pseCode": "1816"
    },
    {
        "id": "a8d4a6aa-03ec-4fc1-97ae-534865ac9300",
        "description": "DALE",
        "pseCode": "1097"
    },
    {
        "id": "7808d3b6-73b9-4c82-8e7d-f711ef293438",
        "description": "DAVIbank S.A.",
        "pseCode": "1019"
    },
    {
        "id": "6ced783b-42fe-4f1d-b0ef-e10dcd76e0d2",
        "description": "DAVIPLATA",
        "pseCode": "1551"
    },
    {
        "id": "7511c12c-73b9-4e15-9fd4-2cf60e0ea4fa",
        "description": "DING",
        "pseCode": "1802"
    },
    {
        "id": "8fc19d64-7f39-4c02-9e73-2d2d4a5ca12d",
        "description": "FINANCIERA JURISCOOP SA COMPAÑIA DE FINANCIAMIENTO",
        "pseCode": "1121"
    },
    {
        "id": "1b66acd4-61f1-4208-ad03-6aecfd7a26f4",
        "description": "GLOBAL66",
        "pseCode": "1814"
    },
    {
        "id": "516fcb53-49a8-4be5-aeb2-0bc594b07789",
        "description": "IRIS",
        "pseCode": "1637"
    },
    {
        "id": "d821a449-691e-488e-974c-0815fef169bc",
        "description": "JFK COOPERATIVA FINANCIERA",
        "pseCode": "1286"
    },
    {
        "id": "6d65f190-1d93-481c-a8f2-3d3d77de29e6",
        "description": "LULO BANK",
        "pseCode": "1070"
    },
    {
        "id": "9a04306f-e885-49f4-b5a3-f192053566a1",
        "description": "MOVII S.A.",
        "pseCode": "1801"
    },
    {
        "id": "17be77df-4d34-4407-96c8-c01f2e620e84",
        "description": "NEQUI",
        "pseCode": "1507"
    },
    {
        "id": "c9307584-45c0-4c71-b5cb-c54ca5934441",
        "description": "NU",
        "pseCode": "1809"
    },
    {
        "id": "a77da9bb-0890-4453-a168-5a5c5089ede7",
        "description": "PAYCASH",
        "pseCode": "1824"
    },
    {
        "id": "7e6fba0d-3e45-4854-b6a3-1f6132378639",
        "description": "POWWI",
        "pseCode": "1803"
    },
    {
        "id": "e271bb11-ddf8-41f9-8081-1ab3ecc5ca14",
        "description": "RAPPIPAY",
        "pseCode": "1811"
    },
    {
        "id": "64aac865-29e4-4d28-8ef0-745c1b4a0432",
        "description": "UALÁ",
        "pseCode": "1804"
    }
];
